export class StationDataItemInfo {

	constructor() {

		this.lineName = null;
		this.stationUuid = null;
		this.uuid = null;
	}


	static GetStationDataItem(jsonItem) {
		let dataItem = null;
		if (jsonItem == null) return dataItem;

		dataItem = new StationDataItemInfo();
		dataItem.stationUuid = jsonItem.stationUuid;
		dataItem.lineName = jsonItem.lineName;
		dataItem.uuid = jsonItem.uuid;
		return dataItem;
	}

}//end StationDataItemInfo

